import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";

import { Button } from "@/components/ui/button";

export default function Page404() {
  return (
    <>
      <Helmet>
        <title>404 Page Not Found | Betterfield</title>
      </Helmet>
      <main className="flex min-h-screen flex-col items-center justify-center px-6 py-24 text-center">
        <div className="mx-auto flex w-full max-w-md flex-col items-center">
          <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">
            Sorry, page not found!
          </h1>
          <p className="mt-4 text-muted-foreground">
            Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve
            mistyped the URL? Be sure to check your spelling.
          </p>
          <img
            src={`${import.meta.env.BASE_URL}static/illustrations/illustration_404.svg`}
            alt=""
            className="my-10 h-64 sm:my-16"
          />
          <Button asChild size="lg">
            <RouterLink to="/">Go to Home</RouterLink>
          </Button>
        </div>
      </main>
    </>
  );
}
